import { Button, TTimelineItemLegacyType } from '@commenda/kakashi';
import { WorkRequestResponseType } from '@commenda/types/src/work-request/types';
import { IncorporationRequestStatus } from '@prisma/client';
import React from 'react';
import AgentRejectWarningBanner from './AgentRejectWarningBanner';
import ChatSidebar from './ChatSidebar';
import IncorporationFormSidebar from './IncorporationFormSidebar';

const IncorporationFormLayout = ({
  steps,
  setActiveStep,
  activeStep,
  children,
  status,
  onClose,
  workRequestData,
  userId,
  companyId,
}: {
  steps: TTimelineItemLegacyType[];
  setActiveStep: (idx: number) => void;
  activeStep: TTimelineItemLegacyType;
  children: React.ReactNode;
  status?: IncorporationRequestStatus;
  onClose: () => void;
  workRequestData?: WorkRequestResponseType;
  userId?: string;
  companyId?: number;
}) => {
  return (
    <main className="flex">
      <IncorporationFormSidebar
        steps={steps}
        setActiveStep={setActiveStep}
        status={status}
      />
      <div className="flex flex-col w-full h-screen">
        <div className="flex py-4 px-10 items-center justify-between border-b border-b-stroke-3 w-full">
          <h2>{activeStep.text}</h2>
          <Button variant="secondary" onClick={onClose}>
            <span>Close</span>
          </Button>
        </div>
        <AgentRejectWarningBanner workRequestData={workRequestData} />
        <div className="w-full h-[calc(100vh-130px)] flex">
          {children}
          <ChatSidebar workRequestData={workRequestData} userId={userId} />
        </div>
      </div>
    </main>
  );
};

export default IncorporationFormLayout;
